import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import BatchTable from "./Component/BatchTable"


const Batch =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <BatchTable />
        </div>
        <Footer />
        </>
    )
}

export default Batch